/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_External_Data_DescInputs */

const es_tyc_definitions_external_data_desc = /** @type {(inputs: Tyc_Definitions_External_Data_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion recuperada en tiempo real de Fuentes Conectadas mediante consultas activas.`)
};

const en_tyc_definitions_external_data_desc = /** @type {(inputs: Tyc_Definitions_External_Data_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information retrieved in real time from Connected Sources through active queries.`)
};

/**
* | output |
* | --- |
* | "Information retrieved in real time from Connected Sources through active queries." |
*
* @param {Tyc_Definitions_External_Data_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_external_data_desc = /** @type {((inputs?: Tyc_Definitions_External_Data_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_External_Data_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_external_data_desc(inputs)
	return en_tyc_definitions_external_data_desc(inputs)
});
export { tyc_definitions_external_data_desc as "tyc.definitions.external_data_desc" }